const enrichCardsData = [
    {
      step: 'step 1',
      title: 'Navigate to HubSpot',
      text: 'Open HubSpot and navigate to the \'Companies\' section by clicking on the button below to find the company you wish to update.',
    },
    {
      step: 'step 2',
      title: 'Locate dossier number',
      text: 'This is located in the company\'s properties. If it\'s not immediately visible, check the settings or consult an administrator.',
    },
    {
      step: 'step 3',
      title: 'Enter or update',
      text: 'Enter the new dossier number into the designated field. If you are updating an existing dossier number, replace the old number with the correct new one.',
    },
    {
      step: 'step 4',
      title: 'Save changes',
      text: 'After entering or updating the dossier number, click \'Save\' to confirm the changes. This will trigger the connected data enrichment processes.',
    },
    {
      step: 'step 5',
      title: 'Verify data',
      text: 'Once the changes are saved, check the company\'s data to ensure that the information reflects the updated dossier number.',
    },
  ];

export default enrichCardsData;



